module.exports = __webpack_public_path__ + "static/img/B-1-min.cc4a9c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/B-1-min.jpg
// module id = 297
// module chunks = 1